import ReceiptSummaryApi from '../../api/receipt-summary-api'
import { request } from './auth-actions'
import { notify } from './notification-actions'
import { getText } from '../../internal/TextLabels'
import { NOTIFY_SUCCESS, NOTIFY_DANGER } from './action-types'
import { silentError } from './action-utils'

export const sendReceiptSummary = (paymentId, index, email) => dispatch => {
  return dispatch(
    request(ReceiptSummaryApi.sendReceiptSummary(paymentId, index, email)),
  )
    .then(() => {
      notify(NOTIFY_SUCCESS, getText('payApply.paymentDone.emailSent'))
    })
    .catch(error => {
      silentError(error)
      notify(NOTIFY_DANGER, getText('payApply.paymentDone.emailError'))
    })
}
